import { render, staticRenderFns } from "./BaseDraftLink.vue?vue&type=template&id=31537e06&scoped=true&"
import script from "./BaseDraftLink.vue?vue&type=script&lang=js&"
export * from "./BaseDraftLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseDraftLink.vue?vue&type=style&index=0&id=31537e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31537e06",
  null
  
)

export default component.exports